import React from 'react'
import Button from '@mui/material/Button'
import { SxProps, Theme, useMediaQuery } from '@mui/material'
interface Props {
  handleClick: () => void
  sx?: SxProps<Theme>
  variant?: 'principal' | 'secondary'
  title: string
  icon?: React.ReactNode
  disabled?: boolean
  hideTextOnMobile?: boolean
  type?: 'button' | 'submit' | 'reset'
}
const getStylesPrincipal = (isSmallMobile: boolean, isMobile: boolean) => ({
  backgroundColor: 'secondary.main',
  py: '11px',
  fontSize: isSmallMobile ? '13px' : isMobile ? '14px' : '15px',
  color: 'white',
  minWidth: '50px',
  minHeight: isSmallMobile ? '40px' : isMobile ? '44px' : '50px',
  '&:hover': {
    backgroundColor: 'primary.main',
    boxShadow: 'none',
  },
})

const getStylesSecondary = (isSmallMobile: boolean, isMobile: boolean) => ({
  backgroundColor: 'white',
  py: '10px',
  fontSize: isSmallMobile ? '11px' : isMobile ? '12px' : '12px',
  minHeight: isSmallMobile ? '36px' : isMobile ? '40px' : '44px',
  border: '2px solid #444D4E',
  color: 'primary.main',
  '&:hover': {
    backgroundColor: 'primary.main',
    color: 'white',
    boxShadow: 'none',
  },
})
const ContainedButton = ({
  handleClick,
  sx,
  title,
  variant = 'principal',
  icon,
  disabled = false,
  hideTextOnMobile = false,
  type = 'button'
}: Props) => {
  const isSmallMobile = useMediaQuery('(max-width: 480px)')
  const isMobile = useMediaQuery('(max-width: 800px)')
  
  const shouldShowText = !hideTextOnMobile || !isSmallMobile
  
  return (
    <Button
      variant='contained'
      sx={{
        px: isSmallMobile ? '16px' : isMobile ? '24px' : '30px',
        fontWeight: '700',
        borderRadius: '0px',
        letterSpacing: '1px',
        boxShadow: 'none',
        lineHeight: isSmallMobile ? '14px' : '16px',
        ...(hideTextOnMobile && isSmallMobile && {
          minWidth: '40px',
          px: '8px',
          '& .MuiButton-startIcon': {
            margin: '0',
          },
        }),
        ...(variant === 'principal' ? getStylesPrincipal(isSmallMobile, isMobile) : getStylesSecondary(isSmallMobile, isMobile)),
        ...sx,
      }}
      onClick={handleClick}
      {...(icon && { startIcon: icon })}
      disabled={disabled}
      type ={type}   
      >
      {shouldShowText && <span>{title}</span>}
    </Button>
  )
}

export default ContainedButton
